import styled from "styled-components";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.mobile} 20px;

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const Wrapper = styled.div`
  > h1 {
    text-align: center;
  }
`;

export const WrapperButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 32px auto;
  max-width: 700px;
  width: 100%;
`;
